<template lang="html">
    <div class="avatar">
        <!-- avatar from vuetify -->
        <v-avatar :size="size" :class="defaultImg ? '' : bgColor" :style="{zIndex: zIndex, 'min-width':size}">
            <!-- if tooltip on avatar  -->
            <template v-if="tooltip">
                <v-tooltip v-model="show" right>
                    <template v-if="item[field]">
                        <img :src="item[field]" slot="activator"/>
                    </template>
                    <template v-else>
                        <div slot="activator">
                        {{ content }}
                        </div>
                    </template>
                    <span>{{item.first_name}} {{item.last_name}}</span>
                </v-tooltip>
            </template>

            <template v-else>
                <template v-if="item[field]">
                    <img :src="item[field]" v-if="item[field]"/>
                </template>
                <template v-else>
                    <template v-if="defaultImg">
                        <img :src="defaultImg" v-if="defaultImg"/>
                    </template>
                    <template v-else>
                        <div>
                            {{ content }}
                        </div>
                    </template>
                </template>
            </template>
        </v-avatar>
    </div>
</template>

<script>
    import { Colors }     from '../../config/enum/Colors.js'

    export default {

        props: {
            size: {
                type: String,
                required: false,
                default: '5rem'
            },
            item: {
                type: Object,
                required: true
            },
            field: {
                type: String,
                required: false,
                default: 'avatar'
            },
            zIndex: {
                type: Number,
                required: false
            },
            tooltip: {
                type: Boolean,
                required: false
            },
            defaultImg: {
                required: false
            }
        },

        data() {
            return {
                show: false
            }
        },

        computed: {
            // if no images -- get first letter of item
            content() {
                if(this.item.name) {
                    return this.item.name[0]

                } else if(this.item.first_name) {
                    if(this.item.last_name) {
                        return this.item.first_name[0] + this.item.last_name[0]
                    }
                    else {
                        return this.item.first_name[0]
                    }
                } else if(this.item.label) {
                    return this.item.label[0]
                } else {
                    return null
                }
            },
            // if no images -- generate a background-color
            bgColor() {
                let color = null

                if(!this.item.avatar && this.item.id) {
                    color = Colors[this.item.id%10]['value']
                }

                return color
            }
        }
    }
</script>

<style lang="stylus" scoped>
@require '../../assets/css/main'
.avatar{
    text-transform: uppercase
    .avatar {
        background-color: #FFFFFF
        img {
            object-fit: contain
            height: 100%
            width: 100%
            background-color: white
        }
    }
    div {
        width: 100%
        height: 100%
        display: flex
        align-items: center
        justify-content: center
    }
}
</style>



// WEBPACK FOOTER //
// src/components/avatar/Avatar.vue